import { JSONSchema7 } from 'json-schema';
import ControlState from '../../Shared/controlState';
import JSONSchema7Properties from '../../Shared/jSONSchema7Properties';
import PageState from '../../Shared/pageState';
import { WorkflowEngineState, SwitchComponent } from '../workflowEngineReducer';

const changeControlIds = (control: ControlState, pageId: string) => {
  const schemaId = `#${pageId}/${control.id}`;

  const newSchema = control.schema as JSONSchema7;
  newSchema.$id = schemaId;

  const newSchemaProps = newSchema.properties as JSONSchema7Properties;

  // Change ids on each custom props
  for (const keyProp in newSchemaProps) {
    newSchemaProps[keyProp].$id = `${schemaId}/${keyProp}`;
  }

  return {
    id: control.id,
    pageId: pageId,
    building: control.building,
    schema: {
      ...newSchema,
      properties: newSchemaProps
    },
    kind: control.kind
  } as ControlState;
};

export default (state: WorkflowEngineState, switchData: SwitchComponent) => {
  state.pages.forEach((page: PageState) => {
    const pageSchema = page.schema as JSONSchema7;
    const pageProperties = pageSchema.properties as JSONSchema7Properties;
    if (page.id === switchData.control.pageId) {
      // Delete control from source page
      delete pageProperties[switchData.control.id];
      page.controls = page.controls.filter(
        (c) => c.id !== switchData.control.id
      );
    }

    if (page.id === switchData.targetPageId) {
      const newControl = changeControlIds(
        switchData.control,
        switchData.targetPageId
      );

      // add to schema
      pageProperties[newControl.id] = newControl.schema as JSONSchema7;
      // add to in-memory collection
      page.controls = [...page.controls, newControl];
      return;
    }
  });
  return { ...state };
};
